import type { Questionnaire } from "@/models/questionnaire";
import type ReceivedQuestionnaire from "@/models/receivedQuestionnaire";
import { defineStore } from "pinia";

export interface SenderState {
  questionnaireId: string;
  questionnaireLabel: string;
  templateId: string;
  contextId: string;
  canSendToBP: boolean;
  isQuestionnairesOwner: boolean;
  isBusinessPartner: boolean;
}

export const useSenderStore = defineStore("sender", {
  state: (): SenderState => ({
    questionnaireId: "",
    questionnaireLabel: "",
    templateId: "",
    contextId: "",
    canSendToBP: true,
    isQuestionnairesOwner: false,
    isBusinessPartner: false,
  }),

  actions: {
    setOwnerParams(questionnaire: Questionnaire): void {
      this.questionnaireId = questionnaire.id;
      this.questionnaireLabel = questionnaire.label;
      this.templateId = questionnaire.templateId;
      this.contextId = "";
      this.canSendToBP = true;
      this.isQuestionnairesOwner = true;
      this.isBusinessPartner = false;
    },

    setSupplierParams(questionnaire: ReceivedQuestionnaire): void {
      this.questionnaireId = questionnaire.questionnaireId;
      this.questionnaireLabel = questionnaire.questionnaireLabel;
      this.templateId = questionnaire.templateId;
      this.contextId = questionnaire.contextId;
      this.canSendToBP = false;
      this.isQuestionnairesOwner = false;
      this.isBusinessPartner = questionnaire.isBusinessPartner;
    },
  },
});
